import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { BrandingService } from './branding.service';

/**
 * Service for checking feature flags.
 * Feature flags are sourced from the application branding.
 */
@Injectable({ providedIn: 'root' })
export class FeatureFlagService {
	constructor(private brandingService: BrandingService) {}

	/**
	 * Check if a feature flag is enabled synchronously.
	 * Returns false if branding is not loaded or flag doesn't exist.
	 */
	isEnabled(flag: string): boolean {
		const branding = this.brandingService.current;
		return branding?.featureFlags?.[flag] ?? false;
	}

	/**
	 * Check if a feature flag is enabled as an observable.
	 * Useful for reactive components.
	 */
	isEnabled$(flag: string): Observable<boolean> {
		return this.brandingService.branding$.pipe(map((branding) => branding?.featureFlags?.[flag] ?? false));
	}

	/**
	 * Get all feature flags from current branding.
	 */
	getAllFlags(): Record<string, boolean> {
		const branding = this.brandingService.current;
		return branding?.featureFlags ?? {};
	}
}
